<template lang="html">
  <modal name="remove-user-modal" height="auto" width="416" :adaptive="true" :maxWidth="416" class="remove-user-modal" @before-open="beforeOpen">
    <div class="modal-container">
      <div class="modal-body">
        <div class="bold black body_17">Remove {{email}}?</div>
        <div class="error-message" v-if="error">{{error}}</div>
      </div>
      <div class="line-break-gray" />
      <div class="modal-footer flex-box">
      <div class="cancel-section">
        <SymbiumButton
          kclass="btn-base dialog-btn"
          :isSmall="true"
          :text="'Cancel'"
          :onClick="() => this.$modal.hide('remove-user-modal')"
        />
      </div>

      <SymbiumButton
        kclass="btn-base remove-user"
        :isSmall="true"
        :text="'Remove User'"
        :onClick="removeUser"
        :loading="loading"
      />
    </div>
    </div>
  </modal>
</template>

<script>
import SymbiumButton from 'src/components/common/SymbiumButton.vue'
import EventBus from 'src/components/EventBus.js'

export default {
  components: { SymbiumButton },
  data() {
    return {
      loading: false,
      productName: null,
      email: null,
      error: null,
    }
  },
  methods: {
    removeUser() {
      this.loading = true;
      var data = { email: this.email, productName: this.productName }
      this.$organization.removeUser(data, this.afterRemoveUser, this.afterFailedRemoveUser)
    },
    afterRemoveUser() {
      EventBus.$emit('buildplus-user-removed', this.email)
    },
    afterFailedRemoveUser(data) {
      this.error = data.errors ? data.errors.base : `Error while removing user`;
      this.loading = false;
    },
    beforeOpen(event) {
      this.email = event.params.email;
      this.productName = event.params.productName;
      this.loading = false;
    }
  },
}
</script>

<style lang="scss">

.remove-user-modal {
  .cancel-section {
    flex-grow: 1;
    text-align: left;
  }

  .modal-body {
    min-height: auto !important;
  }

  .remove-user {
    min-width: 123px;
    background: var(--black);
  }
}
</style>
